import { DossierNames } from '../models';

export class DossierPlaceholderUtils {
  // TODO: Cannot use translationkeys here, why?
  // dossierNames
  // dossierNames labels
  private static productName = 'enums.dossierNames.productName';
  private static productNumber = 'enums.dossierNames.productNumber';
  private static orgaName = 'enums.dossierNames.orgUnitName';
  private static productDescription = 'enums.dossierNames.productDescription';
  private static vpProjectName = 'enums.dossierNames.vpProductName';
  private static vpNumber = 'enums.dossierNames.vpNumber';
  private static other = 'enums.dossierNames.includeYourOwnText';

  // dossierNames examples
  private static productNameExample = 'enums.dossierNames.productNameExample';
  private static productNumberExample = 'enums.dossierNames.productNumberExample';
  private static orgaNameExample = 'enums.dossierNames.orgUnitNameExample';
  private static productDescriptionExample = 'enums.dossierNames.productDescriptionExample';
  private static vpProjectNameExample = 'enums.dossierNames.vpProductNameExample';
  private static vpNumberExample = 'enums.dossierNames.vpNumberExample';
  private static otherExample = 'enums.dossierNames.otherExample';

  static getTranslationKey(dossierName: DossierNames): string {
    let translationKey = '';
    switch (dossierName) {
      case DossierNames.PRODUCTNAME:
        translationKey = DossierPlaceholderUtils.productName;
        break;
      case DossierNames.PRODUCTNUMBER:
        translationKey = DossierPlaceholderUtils.productNumber;
        break;
      case DossierNames.ORGANAME:
        translationKey = DossierPlaceholderUtils.orgaName;
        break;
      case DossierNames.PRODUCTDESCRIPTION:
        translationKey = DossierPlaceholderUtils.productDescription;
        break;
      case DossierNames.VP_PROJECT_NAME:
        translationKey = DossierPlaceholderUtils.vpProjectName;
        break;
      case DossierNames.VP_NUMBER:
        translationKey = DossierPlaceholderUtils.vpNumber;
        break;
      case DossierNames.OTHER:
        translationKey = DossierPlaceholderUtils.other;
        break;
    }

    return translationKey;
  }

  static getTranslationKeyForExample(dossierName: DossierNames): string {
    let translationKey = '';
    switch (dossierName) {
      case DossierNames.PRODUCTNAME:
        translationKey = DossierPlaceholderUtils.productNameExample;
        break;
      case DossierNames.PRODUCTNUMBER:
        translationKey = DossierPlaceholderUtils.productNumberExample;
        break;
      case DossierNames.ORGANAME:
        translationKey = DossierPlaceholderUtils.orgaNameExample;
        break;
      case DossierNames.PRODUCTDESCRIPTION:
        translationKey = DossierPlaceholderUtils.productDescriptionExample;
        break;
      case DossierNames.VP_PROJECT_NAME:
        translationKey = DossierPlaceholderUtils.vpProjectNameExample;
        break;
      case DossierNames.VP_NUMBER:
        translationKey = DossierPlaceholderUtils.vpNumberExample;
        break;
      case DossierNames.OTHER:
        translationKey = DossierPlaceholderUtils.otherExample;
        break;
    }

    return translationKey;
  }
}
